import React, {createContext, useContext, useReducer} from "react"
import {SblDeviceOverviewReducer} from "../reducer/SblDeviceOverviewReducer";
import {PermissionsContext} from "../../../permissions/PermissionsContext";
import PermissionAlertBanner from "../../../commonui/PermissionAlertBanner";

export const SblDeviceOverviewContext = createContext();

const SblDeviceOverviewContextProvider = (props) => {
    const data = []
    const [viewModel, dispatch] = useReducer(SblDeviceOverviewReducer, data)
    const {isAuthorised} = useContext(PermissionsContext);

    if (!isAuthorised){
        return (
            <PermissionAlertBanner/>
        );
    }

    return (
        <SblDeviceOverviewContext.Provider value = {{viewModel, dispatch}}>
            {props.children}
        </SblDeviceOverviewContext.Provider>
    )
}

export default SblDeviceOverviewContextProvider



// WEBPACK FOOTER //
// ./src/components/devicemanagement/sbldevice/context/SblDeviceOverviewContext.js